import { render, staticRenderFns } from "./ThoughtQuestion.vue?vue&type=template&id=99cec39a&"
import script from "./ThoughtQuestion.vue?vue&type=script&lang=js&"
export * from "./ThoughtQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports